import SvgChevronLeft from '@img/icons/chevron-left.svg';
import SvgChevronRight from '@img/icons/chevron-right.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Pagination.styles';
const Pagination = ({ altTheme }) => {
    const carousel = useCarouselContext();
    const count = carousel.maxIndex + 1;
    const cssVars = {
        '--count': count,
        '--progress': (carousel.activeIndex + 1) / count,
    };
    return (React.createElement(S.Container, { style: cssVars, "data-alt-theme": altTheme },
        React.createElement(S.ProgressWrapper, null,
            React.createElement(S.Progress, { role: "progressbar", "aria-valuemax": count, "aria-valuenow": carousel.activeIndex + 1, "aria-label": `Slide ${carousel.activeIndex + 1} of ${count}` }),
            React.createElement(S.List, null, Array.from(Array(count)).map((_, index) => (React.createElement(S.Item, { key: index },
                React.createElement(S.Button, { "aria-label": `Go to ${index + 1}`, onClick: (event) => {
                        event.preventDefault();
                        carousel.goToIndex(index);
                    } })))))),
        React.createElement(S.ControlsWrapper, null,
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.ControlButton, { "aria-label": "Previous", onClick: (event) => {
                        event.preventDefault();
                        carousel.goToPrev();
                    } },
                    React.createElement(SvgChevronLeft, null))),
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.ControlButton, { "aria-label": "Next", onClick: (event) => {
                        event.preventDefault();
                        carousel.goToNext();
                    } },
                    React.createElement(SvgChevronRight, null))))));
};
export default Pagination;
